import routes from './module/routes';
import store from './module/store';

export default {
  name: 'login-simple',
  routes,
  store,
};
